// Centralized logger utility to standardize logging and avoid no-console in app code
// Use environment flags to control verbosity in production builds

type LogLevel = 'debug' | 'info' | 'warn' | 'error'

function isDebugEnabled(): boolean {
  // Vite exposes env via import.meta.env
  // Enable debug when explicitly set; default false in production
  const debugFlag = (import.meta as unknown as { env?: { VITE_DEBUG_LOGS?: string } })?.env?.VITE_DEBUG_LOGS
  return String(debugFlag).toLowerCase() === 'true'
}

function formatPrefix(level: LogLevel): string {
  const ts = new Date().toISOString()
  return `[${ts}] [${level.toUpperCase()}]`
}

export const logger = {
  debug: (...args: unknown[]) => {
    if (isDebugEnabled()) {
      console.debug(formatPrefix('debug'), ...args)
    }
  },
  info: (...args: unknown[]) => {
    console.info(formatPrefix('info'), ...args)
  },
  warn: (...args: unknown[]) => {
    console.warn(formatPrefix('warn'), ...args)
  },
  error: (...args: unknown[]) => {
    console.error(formatPrefix('error'), ...args)
  },
}

export default logger


